var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerIcon = function SvgHamburgerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.017.704H4.87c-.495 0-.99-.042-1.484-.126L0 0v3.333h14.444V0l-4.146.61a8.553 8.553 0 0 1-1.28.094Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.156 9.101H8.263c-.822 0-1.645-.045-2.465-.137l-5.624-.63v3.635h24V8.333L17.284 9c-.708.07-1.417.102-2.128.102Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.156 9.101H8.263c-.822 0-1.645-.045-2.465-.137l-5.624-.63v3.635h24V8.333L17.284 9c-.708.07-1.417.102-2.128.102Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.156 17.737H8.263c-.822 0-1.645-.046-2.465-.138l-5.624-.63v3.635h24V16.97l-6.89.665c-.708.07-1.417.103-2.128.103Z"
  })));
};
export default SvgHamburgerIcon;